import React, { useContext, useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { FormControl, FormControlLabel } from "@mui/material";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import { CredsContext } from "./Contexts";
import Tools from "./JNSTools";
import "./styles/Settings.css";

function SettingsProjectsFinishDate(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  let settings;
  const settingsRaw = localStorage.getItem("oadaSettings");
  if (settingsRaw) {
    settings = JSON.parse(settingsRaw);
  }
  const [finishDateField, setFinishDateField] = useState();
  const dateFields = useRef([]);

  const handleDropdownChange = (event) => {
    settings.projectFinishDateField = event.itemData.fieldname;
    settings.projectFinishDateFieldLabel = event.itemData.text;
    localStorage.setItem("oadaSettings", JSON.stringify(settings));
    Tools.writeSettings(creds, projectObject.id);
  };

  const fieldOptions = { text: "text", value: "fieldname" };

  const formControlLabelStyle = {
    "& .MuiFormControlLabel-label": {
      width: 275,
      color: "white",
    },
  };

  useEffect(() => {
    props.waitHandler(true);
    dateFields.current.push({
      text: "Standard Finish Date",
      fieldname: "finish_date",
    });
    const authString = Tools.getXmlBodyAuthString(creds);
    const urlString = Tools.getInstanceUrl(creds);

    const requestString =
      authString +
      '<Read type="CustField" method="equal to" limit="1000"><CustField><picker>date</picker><association>project</association></CustField></Read></request>';

    Tools.fetchPost(requestString, urlString, "CustField").then(
      (rawCustFields) => {
        if (rawCustFields.xml.length > 0) {
          const custFieldArray = Tools.xmlToArray(rawCustFields.xml);
          for (let i = 0; i < custFieldArray.length; i++) {
            dateFields.current.push({
              text: custFieldArray[i].title.replace(/<br>/g, " "),
              fieldname: custFieldArray[i].name + "__c",
            });
          }
        }
        props.waitHandler(false);
        setFinishDateField(
          settings.projectFinishDateFieldLabel || "Standard Finish Date",
        );
      },
    );
  }, []);

  return (
    <Box>
      <FormControl>
        <FormControlLabel
          labelPlacement="start"
          control={
            <DropDownListComponent
              dataSource={dateFields.current}
              defaultValue={finishDateField}
              fields={fieldOptions}
              select={handleDropdownChange}
              width="250px"
              cssClass="settingReqCategoryDropdown"
            />
          }
          sx={{ ...formControlLabelStyle }}
          label="Field to use for Project finish date: "
        />
      </FormControl>
    </Box>
  );
}

export default SettingsProjectsFinishDate;

SettingsProjectsFinishDate.propTypes = {
  waitHandler: PropTypes.func,
};
